let routes = [
  {
    path: '/',
    name: 'Download',
    component: () => import('@/views/download/pages/Download251208.vue'),
    meta: {
      title: '下载页'
    }
  },
  {
    path: '/preview',
    name: 'Download',
    component: () => import('@/views/download/pages/DownloadPrev.vue'),
    meta: {
      title: '下载页'
    }
  }
]

routes = [...routes]

export default routes
